import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSlidersVIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M7 6H6V3a1 1 0 0 0-2 0v3H3a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm-2 4a1.0002 1.0002 0 0 0-1 1v10a1 1 0 1 0 2 0V11a1 1 0 0 0-1-1Zm7 8a1.0001 1.0001 0 0 0-1 1v2a1.0001 1.0001 0 0 0 2 0v-2a1.0001 1.0001 0 0 0-1-1Zm9-8h-1V3a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 18 3v7h-1a1.0001 1.0001 0 0 0 0 2h4a1.0001 1.0001 0 0 0 0-2Zm-2 4a1.0001 1.0001 0 0 0-1 1v6a1.0001 1.0001 0 0 0 2 0v-6a1.0001 1.0001 0 0 0-1-1Zm-5 0h-1V3a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 11 3v11h-1a1.0002 1.0002 0 0 0-.7071 1.7071c.1875.1875.4419.2929.7071.2929h4a1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineSlidersVIcon
